import { render, staticRenderFns } from "./AttendServicesReservation.vue?vue&type=template&id=0e8c7272&scoped=true&"
import script from "./AttendServicesReservation.vue?vue&type=script&lang=js&"
export * from "./AttendServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8c7272",
  null
  
)

export default component.exports